import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { authResolver } from './pages/_shared/auth.resolver';
import { AdminComponent } from './pages/admin/admin.component';
import { AssignmentsComponent } from './pages/assignments/assignments.component';
import { SessionGoalComponent } from './pages/goal/session-goal.component';
import { HistoryComponent } from './pages/history/history.component';
import { HomeComponent } from './pages/home/home.component';
import { LeaderboardComponent } from './pages/leaderboard/leaderboard.component';
import { InvitationConnectionComponent } from './pages/leads/invitation-connection/invitation-connection.component';
import { LeadsReportsComponent } from './pages/leads/leads-reports/leads-reports.component';
import { SecondMessageComponent } from './pages/leads/second-message/second-message.component';
import { LoginChromeExtensionComponent } from './pages/login-chrome-extension/login-chrome-extension.component';
import { LoginComponent } from './pages/login/login.component';
import { MaintainanceComponent } from './pages/maintainance/maintainance.component';
import { MembersComponent } from './pages/members/members.component';
import { MethodologyComponent } from './pages/methodology/methodology.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { ObjectionBaseComponent } from './pages/objection/objection.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ProductComponent } from './pages/product/product.component';
import { ProjectSettingsComponent } from './pages/project-settings/project-settings.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { ResumeComponent } from './pages/resume/resume.component';
import { ScenarioLibraryComponent } from './pages/scenario-library/scenario-library.component';
import { SessionCopilotRunComponent } from './pages/session-copilot-run/session-copilot-run.component';
import { SessionReportComponent } from './pages/session-report/session-report.component';
import { SessionComponent } from './pages/session/session.component';
import { SignupComponent } from './pages/signup/signup.component';
import { SwitchWorkspacesComponent } from './pages/switch-workspaces/switch-workspaces.component';
import { TagsComponent } from './pages/tags/tags.component';
import { TestComponent } from './pages/test/test/test.component';
import { UploadFilesComponent } from './pages/upload-files/upload-files.component';
import { UsageBillingComponent } from './pages/usage-billing/usage-billing.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: 'home',
    component: HomeComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'leads-invitation',
    component: InvitationConnectionComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'leads-first-message',
    component: SecondMessageComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'reports',
    component: ReportsComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'leaderboard',
    component: LeaderboardComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'leads-reports',
    component: LeadsReportsComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'assignments',
    component: AssignmentsComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'workspace/:id',
    component: HomeComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'switch-workspaces',
    component: SwitchWorkspacesComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'members',
    component: MembersComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'scenario-library',
    component: ScenarioLibraryComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'products',
    component: ProductComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'simulated-meetings/:id',
    component: SessionReportComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'workspace-settings',
    component: ProjectSettingsComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'methodologies',
    component: MethodologyComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'tags',
    component: TagsComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'objections',
    component: ObjectionBaseComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'upload-files',
    component: UploadFilesComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'test-page',
    component: TestComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'maintainance',
    component: MaintainanceComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'my-account',
    component: MyAccountComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'history',
    component: HistoryComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'pricing',
    component: PricingComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'usage-billing',
    component: UsageBillingComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  // {
  //   path: 'dashboard',
  //   component: SessionComponent,
  //   resolve: {
  //     data: homeResolver,
  //   },
  //   canActivate: [authGuard],
  // },
  {
    path: 'goals',
    component: SessionGoalComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'customers',
    component: ResumeComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'practice/:id',
    component: SessionCopilotRunComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'simulated-meetings',
    component: SessionComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  {
    path: 'login-chrome-extension',
    component: LoginChromeExtensionComponent,
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    resolve: {
      data: authResolver,
    },
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '' },
];
